import qs from 'querystring';

const DEEP_LINK_BASE = 'dibs://www.1stdibs.com';
const DEEP_LINK_BASE_MC = 'dibsmc://www.1stdibs.com';

export const deepLinkRegexes = [
    /\/(?:furniture|art|jewelry|fashion)\/section\//,
    /\/sale\/saturday-sale/,
    /\/(?:collections|dealers|locations|creators|shopping-with)/,
    /(?:metal|stone|style|origin|period|material|technique)/,
    /\/(?:furniture|art|jewelry|fashion)/,
    /\/search\//,
    /^\/my\/conversations/,
    /^\/checkout\/id/,
];

export const deepLinkQueries = {
    collection: true,
    creator: true,
    dealer: true,
    gender: true,
    height: true,
    latest: true,
    material: true,
    metal: true,
    origin: true,
    per: true,
    price: true,
    section: true,
    shipping: true,
    sort: true,
    stone: true,
    style: true,
    width: true,
    technique: true,
    utm_medium: true, // eslint-disable-line camelcase
    utm_source: true, // eslint-disable-line camelcase
    utm_campaign: true, // eslint-disable-line camelcase
    utm_content: true, // eslint-disable-line camelcase
    q: true,
    display_title: true, // eslint-disable-line camelcase
    launch: true,
};

export const deepLinkSupported = path => {
    path = path || window.location.pathname;

    let supported = deepLinkRegexes.reduce((acc, item) => {
        if (acc || item.test(path)) {
            return true;
        }
        return false;
    }, false);

    if (path === '/') {
        // home page
        supported = true;
    }

    return supported;
};

function getDeepLinkBase(path) {
    return /^\/my\/conversations/.test(path) ? DEEP_LINK_BASE_MC : DEEP_LINK_BASE;
}

function createDeepLinkPath(path, query) {
    const params = qs.parse(query);
    const supported = Object.keys(params).reduce((acc, item) => {
        if (deepLinkQueries[item]) {
            acc[item] = params[item];
        }
        return acc;
    }, {});
    return `${path}?${qs.stringify(supported)}`;
}

export function createDeepLink() {
    const path = window.location.pathname;
    const query = window.location.search.substr(1);
    return `${getDeepLinkBase(path)}${createDeepLinkPath(path, query)}`;
}



// WEBPACK FOOTER //
// ./src/mobileAds/helpers/deeplink.js